import { useMutation } from "@/compat/reactQuery";
import acknowledgementService from "../../services/acknowledgementService";

const useAcknowledgeDocument = () =>
  useMutation(acknowledgementService.acknowledge);

export default useAcknowledgeDocument;
